import axios from "axios";

export default {
  login(user) {
    return axios({ url: "/users/sign_in", data: user, method: "POST" });
  },
  signup(user) {
    return axios({ url: "/signup", data: user, method: "POST" });
  },
  logout() {
    return axios({ url: "/users/sign_out", method: "DELETE" });
  },
  resetPassword(data) {
    return axios({ url: "/users/password", data, method: "PUT" });
  },
  recoverPassword(data) {
    return axios({ url: "/users/password", data, method: "POST" });
  },
  getUser() {
    return axios({ url: "/user", method: "GET" });
  },
  updateUser() {
    return axios({ url: "/user", method: "PUT" });
  },
  updateBillingAddress(data) {
    return axios({ url: "/user/billing_address", data, method: "PUT" });
  }
};
